<template>
  <a-layout :class="['layout', device]">
    <a-drawer
        v-if="isMobile"
        placement="left"
        :wrapClassName="`drawer-sider ${navTheme}`"
        :closable="false"
        :visible="collapsed"
        @close="drawerClose"
    >
      <side-menu
          mode="inline"
          :menus="menus"
          :theme="navTheme"
          :collapsed="false"
          :collapsible="true"
      ></side-menu>
    </a-drawer>

    <side-menu
        v-else-if="isSideMenu"
        mode="inline"
        :menus="menus"
        :theme="navTheme"
        v-model:collapsed="collapsed"
    ></side-menu>
    <a-layout>
      <GlobalHeader
          :mode="layoutMode"
          :menus="menus"
          :theme="navTheme"
          :collapsed="collapsed"
          :device="device"
          @toggle="toggle"
          @refresh="onRefresh"/>
      <a-layout-content
          :style="{
          height: '100%',
          margin: '24px 24px 0',
          paddingTop: fixedHeader ? '64px' : '0',
        }"
      >
        <multi-tab v-if="multiTab"></multi-tab>
        <transition name="page-transition">
          <section>
            <route-view v-if="showRouter"/>
          </section>
        </transition>
      </a-layout-content>
      <a-layout-footer>
        <GlobalFooter/>
      </a-layout-footer>
    </a-layout>
  </a-layout>
</template>

<script>
import {computed, nextTick, provide, ref} from "vue";
import GlobalHeader from '@/components/GlobalHeader/GlobalHeader'
import GlobalFooter from "@/components/GlobalFooter/GlobalFooter";
import {settingStore} from "@/store/setting";
import {isMobile} from "@/utils/device";
import {mainStore} from "@/store";
import SideMenu from "@/components/Menu/SideMenu";
import MultiTab from "@/components/MultiTab/MultiTab";
import RouteView from "@/layouts/RouteView";

export default {
  name: "BasicLayout",
  components: {
    GlobalHeader,
    SideMenu,
    MultiTab,
    RouteView,
    GlobalFooter,
  },
  setup() {
    const userStore = settingStore();
    const store = mainStore();
    const showRouter = ref(true);
    const collapsed = ref(true);
    const menus = ref([]);
    const routes = store.addRouters.find((item) => item.path === "/");
    menus.value = (routes && routes.children) || [];
    collapsed.value = !userStore.sidebarOpened;
    const drawerClose = () => {
      collapsed.value = false
    }

    const toggle = () => {
      collapsed.value = !collapsed.value
      userStore.sidebar = !collapsed.value
      // triggerWindowResizeEvent()
    }
    const onRefresh = () => {
      showRouter.value = false
      nextTick(() => (showRouter.value = true))
    }

    provide('reload', onRefresh);

    return {
      collapsed,
      device: computed(() => userStore.device),
      isMobile,
      navTheme: computed(() => userStore.theme),
      drawerClose,
      menus,
      isSideMenu: computed(() => userStore.layout === 'sidemenu'),
      toggle,
      onRefresh,
      showRouter,
      layoutMode: computed(() => userStore.layout),
      fixedHeader: computed(() => userStore.fixedHeader),
      multiTab: computed(() => userStore.multiTab),
    };
  }
}
</script>

<style scoped lang="scss">

</style>